var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeCityOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-city-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 2.5V4.76L12 6.09V4.5H22V19.5H17V21.5H24V2.5H10ZM7.5 5.5L0 10.5V21.5H15V10.5L7.5 5.5ZM14 6.5V7.43L15.61 8.5H16V6.5H14ZM18 6.5V8.5H20V6.5H18ZM7.5 8L13 11.5V19.5H10V13.5H5V19.5H2V11.5L7.5 8ZM18 10.5V12.5H20V10.5H18ZM18 14.5V16.5H20V14.5H18Z",
    fill: "#808080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCityOutline);
export default __webpack_public_path__ + "static/media/home-city-outline.01bd47985ccd94d5de244239f9fe18f3.svg";
export { ForwardRef as ReactComponent };